import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 14,
		y: 14,
		width: 12,
		height: 12,
		rx: 2,
		fill: "white",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 10,
		width: 12,
		height: 12,
		rx: 2,
		fill: "white",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
